import { Injectable } from '@angular/core';
import { TableExpandableCards } from '../models';
import { DateTimeService, ExpandableCard, ExpandableCardProperty } from '@shared';

@Injectable({
	providedIn: 'root'
})
export class TimeDataFormattingService {
	public constructor(private dateTimeService: DateTimeService) {}

	public formatTimeFields(tableExpandableCards: TableExpandableCards): TableExpandableCards {
		const modifiedExpandableCards = tableExpandableCards.expandableCards?.map((expandableCard: ExpandableCard) => {
			const modifiedProperties = this.dateTimeService.formatTimeFields(
				expandableCard.properties
			) as ExpandableCardProperty[];
			expandableCard.properties = modifiedProperties;
			return expandableCard;
		});

		tableExpandableCards.expandableCards = modifiedExpandableCards;
		return tableExpandableCards;
	}
}
